/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Icon from './Icon';
import { withParamsAndNavigate } from './WithParamsAndNavigate';
import Menu from './Menu';
import BaseCom from './BaseCom';
import LoadingAlert from './LoadingAlert';

// Unused
class Home extends BaseCom {

  render() {
    return null;
  }
}

export default withParamsAndNavigate(Home);